<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Planning') }}</h1>
        </div>
      </div>

      <b-card class="mt-4 shadow-sm">
        <operation-show-planning :is-global-props="true"></operation-show-planning>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import OperationShowPlanning from "../operation/OperationShowTabs/OperationShowPlanning";

export default {
  name: "PlanningIndex",

  components: {
    OperationShowPlanning,
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/planning/PlanningIndex.vue